"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "payment-page-listing-farms"
  }, [_c("div", {
    staticClass: "context-item-fixed"
  }, [_c("payment-farms-list-component")], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;